import { Grid } from '@mui/material';
import React from 'react';
import styles from './HeaderInfo.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import {
	closeConfirmation,
	setConfirmation,
} from '../../../redux/confirmations/actions';
import { connect } from 'react-redux';
import Confirmation from '../../confirmation/ConfirmationComponent';
import movePurchaserToLead from '../../../api/Purchasers/movePurchaserToLead.api';
import { useHistory, useParams } from 'react-router';

const HeaderInfo = ({
	title,
	subtitle,
	setConfirmation,
	closeConfirmation,
	confirmation,
	salesAgentId,
	lotId,
	onSaveAndExit,
}) => {
	var params = useParams();
	var history = useHistory();

	const handleCloseAps = () => {
		setConfirmation('closeAgreement');
	};

	const handleCloseConfirmation = () => {
		closeConfirmation('closeAgreement');
	};

	const handleDiscardAgreement = () => {
		movePurchaserToLead(params.id, salesAgentId, lotId);
		history.push({
			pathname: '/deals',
		});
		handleCloseConfirmation();
	};

	const handleSaveAgreement = () => {
		onSaveAndExit();
		history.push({
			pathname: '/deals',
		});
		handleCloseConfirmation();
	};

	var buttonList = [
		{
			name: 'Cancel',
			action: () => {
				handleCloseConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Discard',
			action: () => {
				handleDiscardAgreement();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Save & Exit',
			action: () => {
				handleSaveAgreement();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	return (
		<>
			<Grid
				container
				className={styles.headerInfoWrapper}
				justifyContent='space-between'
			>
				<Grid item className={styles.textArea}>
					<div className={styles.title}>{title}</div>
					<div className={styles.subTitle}>{subtitle}</div>
				</Grid>
				<Grid item>
					<div
						className={styles.closeIcon}
						onClick={() => handleCloseAps()}
					>
						<CloseIcon />
					</div>
				</Grid>
			</Grid>
			<Confirmation
				open={confirmation?.closeAgreement}
				handleClose={handleCloseConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={buttonList}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	confirmation: state.confirmation,
	salesAgentId: state.agreement.agreementById?.leadDetails?.leadToSalesAgent,
	lotId: state.agreement.agreementById?.productAvailability?.lotId,
});

export default connect(mapStateToProps, { setConfirmation, closeConfirmation })(
	HeaderInfo
);
